import { MAIN_CONTROLLER } from "@/utils/main_controller";
import { LandingPageLogic } from "@/utils/landing_page_logic";

export default {
  name: "DynamicLandingPage",
  mixins: [MAIN_CONTROLLER, LandingPageLogic],
  computed: {
    branding() {
      const branding = this.$store.state.branding || {
        primary_color: "#59FF74",
        secondary_color: "#212529",
        logo_width: "100px",
        client_text: "dark",
        primary_color_rgb: "rgb(89, 255, 116)",
        secondary_color_rgb: "rgb(33, 37, 41)",
        icon_filter: "",
        table_header_bg: "#59FF74",
        sidebar_bg: "",
        sidebar_theme: "dark",
        welcome_text: "",
        subtext: "Your trusted partner for verification and compliance",
        button_text: "Get Started",
        footer_text: "© 2024 TGPDC. All rights reserved.",
        landing_url: null,
        logo_url: null,
      };
      return branding;
    },
    heroStyle() {
      const styles = {};
      if (this.branding && this.branding.landing_url) {
        styles.backgroundImage = `url(${this.branding.landing_url})`;
      }
      return styles;
    },
    clientName() {
      return this.$client || "Verify Flex";
    },
    welcomeText() {
      if (this.branding && this.branding.welcome_text) {
        return this.branding.welcome_text;
      }
      return `Welcome to ${this.clientName}`;
    },
    subtext() {
      return (this.branding && this.branding.subtext) || "Your trusted partner for verification and compliance";
    },
    buttonText() {
      return (this.branding && this.branding.button_text) || "Get Started";
    },
    footerText() {
      return (
      (this.branding && this.branding.footer_text) ||
      `© ${new Date().getFullYear()} TGPDC. All rights reserved.`
      );
    },
    buttonStyle() {
      const primaryColor = this.branding ? this.branding.primary_color : null;
      const clientText = this.branding ? this.branding.client_text : "dark";
      const textColor = clientText === "light" ? "#f8f9fa" : "#212529";
      const style = primaryColor ? {
        backgroundColor: primaryColor,
        borderColor: primaryColor,
        color: textColor,
      } : { color: textColor };
      return style;
    },
  },
};
